const apiErrorCode = {
  TOKEN_ERROR: "error.JWT_VALIDATION_ERROR",
  AUTH_FAIELD_ERROR: "user.AUTH_FAILED",
  PASSWORD_ERROR: "user.PASSWORD_ERROR",
};

export default apiErrorCode;
